export const syncAuthenticatedUser = async (firebaseUser, fallback = {}) => {
  if (!firebaseUser?.uid || typeof firebaseUser.getIdToken !== "function") {
    throw new Error("Não foi possível validar sua sessão. Entre novamente.");
  }
  const authId = firebaseUser.uid;
  const email = firebaseUser?.email || fallback.email;
  const fullName = firebaseUser?.displayName || fallback.fullName;

  const response = await fetch("/api/users/sync", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await firebaseUser.getIdToken()}`,
    },
    body: JSON.stringify({ authId, email, fullName }),
  });
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(body?.message || "Nao foi possivel sincronizar o usuario no banco.");
  }

  return body;
};
